<template>
  <section v-if="bundles.length" class="bundle-strip">
    <h2 class="bundle-strip__title">{{ $t('shop_bundle.also_as_bundle') }}</h2>
    <div class="bundle-strip__grid">
      <ShopBundleCard v-for="b in bundles" :key="b._id" :bundle="b" />
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue'
import ShopBundleCard from '~/components/Shop/BundleCard.vue'

/**
 * "Also available as a bundle" under a release, a merch product or an
 * artist. Renders nothing while bundles are off or none contain the item.
 * Lazy: the page around it must not wait for it.
 */
const props = defineProps({
  release: { type: String, default: '' },
  merch: { type: String, default: '' },
  artist: { type: String, default: '' }
})
const { tenant } = useTenantTheme()
const query = computed(() => {
  const q = { limit: 6 }
  if (props.release) q.release = props.release
  if (props.merch) q.merch = props.merch
  if (props.artist) q.artist = props.artist
  return q
})
const { data } = await useFetch('/api/shop/bundles', {
  key: `bundle-strip-${props.release || ''}-${props.merch || ''}-${props.artist || ''}`,
  query,
  lazy: true,
  immediate: !!tenant.value?.bundlesEnabled && !!(props.release || props.merch || props.artist),
  default: () => ({ bundles: [] })
})
const bundles = computed(() => data.value?.bundles || [])
</script>

<style scoped>
.bundle-strip { margin-top: 40px; }
.bundle-strip__title {
  font-family: var(--cy-display);
  font-size: 1rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: var(--text-main);
  margin-bottom: 14px;
}
.bundle-strip__grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(180px, 1fr)); gap: 14px; }
</style>
